import React from 'react';
import { createBrowserHistory } from 'history';
import { HashRouter, Router } from 'react-router-dom'
import isElectron from 'is-electron'

/*
 *  @Description:   Component that will choose between BrowserRouter or HashRouter
 */


const history = createBrowserHistory ();

const RouterChooser = ( props ) => {

    if ( isElectron () ) {
        return (
            <HashRouter>
                { props.children }
            </HashRouter>
        )
    }
    return (
        <Router history={ history }>
            { props.children }
        </Router>
    )
}

export default RouterChooser;
